import styled from "styled-components";
import { getColor } from "../themeHandler";

interface CloseButtonProps {
  readonly size?: string;
  readonly modalTheme: string;
}

export const StyledCloseButton = styled.button<CloseButtonProps>`
  font-size: ${(props) => handlerSize(props.size)};
  text-transform: uppercase;
  outline: none;
  border: none;
  font-weight: 700;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  position: absolute;
  top: 1em;
  right: 1.25em;
  color: ${(props) => getColor(props.modalTheme, 'closeButtonColor')};
  transition: all 0.3s ease;
`;

const handlerSize = (iconSize: string) => {
  switch (iconSize) {
    case "xs":
      return "0.9375em";

    case "sm":
      return "1em";

    case "md":
      return "1.125em";

    case "l":
      return "1.1875em";

    case "xl":
      return "1.375em";

    default:
      break;
  }
};

StyledCloseButton.defaultProps = {
  size: "sm",
};
